module.exports = __webpack_public_path__ + "static/media/icon_2_3.d4b0a8a3.svg";